<template>
  <div id="page-selects">
    <v-container grid-list-xl fluid>
      <v-row row wrap>
        <v-col cols="12" lg="12" xs="12">
          <v-dialog v-model="dialogAddGroupObject" width="800" scrollable eager>
            <GroupBrowse ref="addGroup" max-width="800px"
              :receiveVar="sendVar" @eventReturn="getVarReturn">
            </GroupBrowse>
          </v-dialog>
          <v-data-table
            v-model="vDataTable.selected"
            :headers="header"
            :items="vDataTable.data"
            :page.sync="vDataTable.options.page"
            :itemsPerPage.sync="vDataTable.options.itemsPerPage"
            :options.sync="vDataTable.options"
            :search="vDataTable.search"
            show-select
            :footer-props="{
              itemsPerPageText: $t('itemsPerPageText'),
              itemsPerPageAllText: $t('itemsPerPageAllText'),
              showFirstLastPage: true,
              showCurrentPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
            item-key="group_skey"
            class="elevation-1">
            <template v-slot:top>
              <v-toolbar flat>
                <v-btn outlined color="primary" @click="dialogAddGroupObject = true;$refs.addGroup.retrieveGroup()" style="text-transform: capitalize">
                  <img src="../../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>New Group
                </v-btn>
                <v-divider class="mx-1" inset vertical></v-divider>
                <v-btn outlined color="primary" @click="checkDeleteSelectedGroupObject" style="text-transform: capitalize">
                  <img src="../../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>Delete Group
                </v-btn>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="vDataTable.search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details>
                </v-text-field>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon color="red" small @click="deleteItem(item)">delete</v-icon>
            </template>
            <template v-slot:item.access_ind="{ item }">
              <v-autocomplete outlined dense
                single-line
                hide-details
                :items="accessTypeList"
                item-value="code"
                item-text="description"
                @change="editItem(item)"
                v-model="item.access_ind">
              </v-autocomplete>
            </template>
            <template v-slot:no-data>
              <v-alert type="info" dense border="bottom" colored-border elevation="2">
                {{$t('noData')}}
              </v-alert>
            </template>
            <template v-slot:no-results>
              <v-alert type="warning" dense border="bottom" colored-border elevation="2">
                {{stringFormat($t('searchNotFound'),vDataTable.search)}}
              </v-alert>
            </template>
            <template v-slot:footer>
              <tr class="sticky-table-footer" style="position: absolute" >
                  <td>Selected({{vDataTable.selected.length}})s</td> 
              </tr>
            </template>
          </v-data-table>
              <!-- <v-dialog v-model="dialogDeleteGroupObject" persistent width="350" eager>
                <v-card>
                  <p class="text-md-center"><v-icon style="font-size: 100px;" color="red">question_answer</v-icon></p>
                  <v-card-text>
                      <h3 class="headline mb-0"><b><p class="text-md-center">คุณต้องการที่จะลบ Group Object ?</p></b></h3>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      class="mb-2"
                      @click="deleteGroupObject()"
                    >
                    OK
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="mb-2"
                      @click="dialogDeleteGroupObject = false"
                    >
                    Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog> -->
              <!-- <v-dialog v-model="dialogDeleteSelectedGroupObject" persistent width="350" eager>
                <v-card>
                  <p class="text-md-center"><v-icon style="font-size: 100px;" color="red">question_answer</v-icon></p>
                  <v-card-text>
                      <h3 class="headline mb-0"><b><p class="text-md-center">คุณต้องการที่จะลบ Group Object ที่เลือก ?</p></b></h3>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      class="mb-2"
                      @click="deleteSelectedGroupObject()"
                    >
                    OK
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="mb-2"
                      @click="dialogDeleteSelectedGroupObject = false"
                    >
                    Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog> -->
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
  // import 'babel-polyfill'
  import GroupBrowse from '@/components/common/GroupBrowse'
  export default {
    components: {
      GroupBrowse
    },
    props: ['receiveVar', 'parentComponent'],
    data () {
      return {
        utils: require('@/utils'),
        stringFormat: require('string-format'),
        appName: process.env.VUE_APP_DB_APP_NAME,
        dialog: {
          dialogProgress: false,
          dialogAddEditWindow: false,
        },
        showMenu: false,
        x: 0,
        y: 0,
        vDataTable: {
          search: '',
          selected: [],
          data: [],
          editedIndex: -1,
          editedItem: {
            win_name: '',
            window_comment: ''
          },
          defaultItem: {
            win_name: '',
            window_comment: ''
          },
          options: {
            page: 1,
            itemsPerPage: -1,
            sortBy: [],
            sortDesc: [],
            groupBy: [],
            groupDesc: true,
            multiSort: true,
            // mustSort: true
          },
        },
        sendVar: [],
        dialogAddGroupObject: false,
        dialogDeleteGroupObject: false,
        dialogDeleteSelectedGroupObject: false,
        accessTypeList: [
              { code: 0, description: 'No Restriction' },
              { code: 10, description: 'Disable' },
              { code: 20, description: 'Invisible' }],
        search: '',
        pagination: {
          sortBy: 'group_name',
          rowsPerPage: 10
        },
        selected: [],
        data: [],
        header: [
          { text: 'Actions', sortable: false, value: 'actions', align: 'center' },
          { text: 'Group', value: 'group_name', align: 'left' },
          { text: 'Access', value: 'access_ind', align: 'left' },
        ],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        deletedIndex: -1,
        deletedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
      }
    },
    created: function () {
    },
    methods: {
      sendToParentComponent (value) {
        value.childSend = this.$options._componentTag
        this.$emit('eventReturn', value)
      },
      getVarReturn (value) {
        switch (value.childSend) {
          case 'GroupBrowse':
            this.dialogAddGroupObject = false
            switch (value.actionReturn) {
              case 'OK':
                this.addGroupObject(value.dataSelected)
            }
            break
        }
      },
      retrieveGroupObject (objectSkey) {
        this.axios.post(process.env.VUE_APP_API + '/navigation/retrieveGroupObject' + process.env.VUE_APP_DATABASE_TYPE, {
          object_skey: objectSkey
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.vDataTable.data = response.data.data
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      },
      addGroupObject (value) {
        this.axios.post(process.env.VUE_APP_API + '/navigation/addGroupObject' + process.env.VUE_APP_DATABASE_TYPE, {
          object_skey: this.receiveVar.objectSkey,
          to_group: value
        })
          .then(response => {
            if (response.data.isSuccess) {
              var valueSend = []
              this.sendToParentComponent(valueSend)
              this.retrieveGroupObject(this.receiveVar.objectSkey)
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      },
      checkDeleteSelectedGroupObject () {
        if (this.vDataTable.selected.length > 0) {
          /* this.dialogDeleteSelectedGroupObject = true */
          this.deleteSelectedItem()
        } else {
          this.$swal({type: 'error', title: 'กรุณาเลือก Group ที่จะลบ'})
        }
      },
      async asyncForEach (array, callback) {
        for (let index = 0; index < array.length; index++) {
          await callback(array[index], index, array)
        }
      },
      async deleteSelectedItem () {
        this.$swal({
          text: 'คุณต้องการที่จะลบ Group Object ?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then(async (result) => {
          if (result) {
            await this.asyncForEach(this.vDataTable.selected, async function (x) {
              var groupSkey = x.group_skey
              var objectSkey = x.object_skey
              await this.axios.post(process.env.VUE_APP_API + '/navigation/deleteGroupObject' + process.env.VUE_APP_DATABASE_TYPE, {
                group_skey: groupSkey,
                object_skey: objectSkey
              })
                .then(async response => {
                  if (response.data.isSuccess) {
                    this.$swal({type: 'success', title: response.data.reasonText})
                  } else {
                    await this.$swal({type: 'error', title: response.data.reasonText})
                  }
                })
                .catch(async e => {
                  await this.$swal({type: 'error', title: e.message})
                })
            }.bind(this))
            this.retrieveGroupObject(this.receiveVar.objectSkey)
          }
        })
      },
      async deleteItem (item) {
        this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
        this.vDataTable.editedItem = Object.assign({}, item)
        this.$swal({
          text: 'คุณต้องการที่จะลบ Group Object ?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then(async (result) => {
          if (result) {
            var val = await this.deleteGroupObject(this.vDataTable.editedItem)
            if (val !== undefined) {
              this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(this.vDataTable.editedItem), 1)
            }
            this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
            this.vDataTable.editedIndex = -1
          }
        })
      },
      async deleteGroupObject (item) {
        try {
          var groupSkey = item.group_skey
          var objectSkey = item.object_skey
          await this.axios.post(process.env.VUE_APP_API + '/navigation/deleteGroupObject' + process.env.VUE_APP_DATABASE_TYPE, {
            group_skey: groupSkey,
            object_skey: objectSkey
          })
            .then(async response => {
              if (response.data.isSuccess) {
                this.vDataTable.data.splice(this.deletedIndex, 1)
                await this.$swal({type: 'success', title: response.data.reasonText})
              } else {
                this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(e => {
              this.$swal({type: 'error', title: e.message})
            })
        } catch (e) {
          this.$swal({type: 'error', title: e.message})
        } finally {
          this.dialogDeleteGroupObject = false
        }
      },
      async updateGroupObject () {
        try {
          var groupSkey = this.editedItem.group_skey
          var objectSkey = this.editedItem.object_skey
          var accessInd = this.editedItem.access_ind
          await this.axios.post(process.env.VUE_APP_API + '/navigation/updateGroupObject' + process.env.VUE_APP_DATABASE_TYPE, {
            group_skey: groupSkey,
            object_skey: objectSkey,
            access_ind: accessInd
          })
            .then(async response => {
              if (response.data.isSuccess) {
                await this.$swal({type: 'success', title: response.data.reasonText})
              } else {
                this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(e => {
              this.$swal({type: 'error', title: e.message})
            })
        } catch (e) {
          this.$swal({type: 'error', title: e.message})
        } finally {
        }
      },
      editItem (item) {
        this.editedIndex = this.data.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.updateGroupObject()
      },
      toggleAllNode () {
        if (this.selected.length) this.selected = []
        else this.selected = this.data.slice()
      },
      changeSortNode (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
    }
  }
</script>
